import { useState, useMemo } from "react";
import { motion } from "framer-motion";
import { Users } from "lucide-react";
import { Slider } from "@/components/ui/slider";

function recommend(count) {
  if (count <= 100) {
    const price = Math.round((150 + (count / 100) * 150));
    return { pkg: "Paket Starter", price, color: "from-cyan-400 to-cyan-500" };
  }
  if (count <= 300) {
    const price = Math.round(300 + ((count - 100) / 200) * 300);
    return { pkg: "Paket Standard", price, color: "from-cyan-400 to-violet-500" };
  }
  const price = Math.min(1500, Math.round(750 + ((count - 300) / 700) * 750));
  return { pkg: "Paket Pro / Unlimited", price, color: "from-violet-500 to-fuchsia-500" };
}

const fmt = (n) => "Rp " + n.toLocaleString("id-ID") + ".000";

export const PriceCalculator = () => {
  const [count, setCount] = useState([150]);
  const value = count[0];
  const result = useMemo(() => recommend(value), [value]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="mx-auto mt-14 max-w-3xl rounded-2xl border border-cyan-500/20 glass p-6 sm:p-8"
      data-testid="price-calculator"
    >
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
        <div>
          <div className="flex items-center gap-2 text-sm font-medium text-slate-200">
            <Users className="h-4 w-4 text-cyan-400" />
            Perkiraan Jumlah Siswa
          </div>
          <div className="mt-1 font-heading text-3xl font-bold text-white" data-testid="calc-student-count">
            {value >= 1000 ? "1.000+" : value} siswa
          </div>
        </div>
        <div className="text-right">
          <div className="text-xs text-slate-400">Estimasi Biaya</div>
          <div className={`font-heading text-3xl font-bold bg-gradient-to-r ${result.color} bg-clip-text text-transparent`} data-testid="calc-price">
            {fmt(result.price)}<span className="text-base text-slate-400"> / bln</span>
          </div>
        </div>
      </div>

      <div className="mt-7">
        <Slider
          value={count}
          onValueChange={setCount}
          min={20}
          max={1000}
          step={10}
          data-testid="calc-slider"
          className="[&_[role=slider]]:h-5 [&_[role=slider]]:w-5 [&_[role=slider]]:border-cyan-400 [&_[role=slider]]:bg-cyan-400"
        />
        <div className="mt-2 flex justify-between text-xs text-slate-500">
          <span>20</span>
          <span>1.000+</span>
        </div>
      </div>

      <div className="mt-6 flex items-center justify-center rounded-xl border border-cyan-500/20 bg-cyan-950/30 py-3 text-sm">
        <span className="text-slate-300">Rekomendasi paket untuk Anda:&nbsp;</span>
        <span className="font-semibold text-cyan-400" data-testid="calc-recommended-pkg">{result.pkg}</span>
      </div>
    </motion.div>
  );
};
